import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { NzTypographyComponent } from 'ng-zorro-antd/typography';

@Component({
  selector: 'app-appointment-status-info',
  templateUrl: './appointment-status-info.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NzTypographyComponent],
})
export class AppointmentStatusInfoComponent implements OnInit {
  @Input() text = '';
  @Input() type: NzTypographyComponent['nzType'] = 'secondary';

  ngOnInit() {}
}
